export const CLOSE_DIALOG_AVAILABILITY_BLOCKS = 'lumahealth/DialogAvailabilityBlocks/CLOSE_DIALOG_AVAILABILITY_BLOCKS';

export const DIALOG_AVAILABILITY_BLOCKS_FORM = 'lumahealth/DialogAvailabilityBlocks/DIALOG_AVAILABILITY_BLOCKS_FORM';

export const OPEN_DIALOG_AVAILABILITY_BLOCKS = 'lumahealth/DialogAvailabilityBlocks/OPEN_DIALOG_AVAILABILITY_BLOCKS';

export const CHANGE_AVAILABILITY_BLOCKS = 'lumahealth/DialogAvailabilityBlocks/CHANGE_AVAILABILITY_BLOCKS';

export const CHANGE_AVAILABILITY_BLOCKS_APPOINTMENT_TYPE =
  'lumahealth/DialogAvailabilityBlocks/CHANGE_AVAILABILITY_BLOCKS_APPOINTMENT_TYPE';
